module.exports = __webpack_public_path__ + "img/logo1.d8551e1c.png";